export interface GroupListPrintRequest {
  userId: string
}

export function GroupListPrintRequestToJSON(value: GroupListPrintRequest): any {
  return {
    user_id: value.userId
  }
}
